import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Questions } from 'src/Models/Questions';

@Component({
  selector: 'tpl-radiolist',
  templateUrl: './tpl-radiolist.component.html',
  styleUrls: ['./tpl-radiolist.component.sass']
})
export class TplRadiolistComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() objColor: any;
  @Input() question: Questions;

  @Output() nextStep = new EventEmitter<string>();
  @Output() hiddenShowTitle = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
  }

  radioValue(value) {
    let valueQuestion = this.form.get('value').value;
    valueQuestion = value;
    this.form.get('value').setValue(valueQuestion);
  }

  finishQuestion() {
    this.nextStep.emit('')
  }

}
